import { Specs } from '@doxyme/extensions-common';
import ControlCapability from '../control';

const { SidebarMenuControl } = Specs;
type Constraints = Specs.SidebarMenuControl.Constraints;

export default class SidebarMenuControlCapability extends ControlCapability<Constraints> {
  static id = SidebarMenuControl.id;

  constructor() {
    super(SidebarMenuControl);
  }
}
